export const PortasJanelasEFechadurasIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.35093 9.99997C8.89343 10.5083 8.2376 10.8333 7.5001 10.8333C5.9726 10.8333 4.7651 9.46331 5.03927 7.88414C5.2151 6.87414 6.04593 6.04831 7.05593 5.87164C7.97177 5.71247 8.80343 6.05831 9.35093 6.66664H16.6668C17.1268 6.66664 17.5001 7.03997 17.5001 7.49997V9.16664C17.5001 9.62664 17.1268 9.99997 16.6668 9.99997H9.35093Z"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5 10V15.8333C12.5 16.7542 11.7542 17.5 10.8333 17.5H4.16667C3.24583 17.5 2.5 16.7542 2.5 15.8333V4.16667C2.5 3.24583 3.24583 2.5 4.16667 2.5H10.8333C11.7542 2.5 12.5 3.24583 12.5 4.16667V6.66667"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.99992 14.1583C4.99742 14.1583 4.99575 14.16 4.99575 14.1625C4.99575 14.165 4.99742 14.1667 4.99992 14.1667C5.00242 14.1667 5.00409 14.165 5.00409 14.1625C5.00409 14.16 5.00242 14.1583 4.99992 14.1583"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.50407 14.1583C7.50157 14.1583 7.4999 14.16 7.4999 14.1625C7.4999 14.165 7.5024 14.1667 7.50407 14.1667C7.50657 14.1667 7.50824 14.165 7.50824 14.1625C7.50824 14.16 7.50657 14.1583 7.50407 14.1583"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.99992 14.1583C9.99742 14.1583 9.99575 14.16 9.99575 14.1625C9.99575 14.165 9.99742 14.1667 9.99992 14.1667C10.0024 14.1667 10.0041 14.165 10.0041 14.1625C10.0041 14.16 10.0024 14.1583 9.99992 14.1583"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
